var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFirstPattern(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 316,
    height: 390,
    viewBox: "0 0 316 390",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M316 233.69V247.13C310.74 251.58 305.25 255.81 299.53 259.82C272.77 278.58 240.93 292.47 204.9 301.11C168.34 309.88 139.88 315.96 117.01 320.85C49.68 335.24 32.21 338.97 0 369.44V355.89C30.34 329.15 51.39 324.65 114.92 311.07C137.73 306.19 166.13 300.12 202.57 291.39C254.84 278.85 291.14 256.45 316 233.69Z",
    fill: "white",
    fillOpacity: 0.1
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M63.39 0C63.35 9.87 62.37 21.08 59.67 33.64C52 69.24 31.93 107.57 0 147.64V131.34C43.99 72.92 53.39 30.18 53.44 0H63.39Z",
    fill: "white",
    fillOpacity: 0.1
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFirstPattern);
export default __webpack_public_path__ + "static/media/firstPattern.fd879b3ae62fc3dbff28174a4c67c6c1.svg";
export { ForwardRef as ReactComponent };